// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"83d4d78d","16":"b17cef70","300":"51cd0167","453":"127be8e2","597":"b744ca37","652":"5ec7428f","890":"32b8ab49","975":"1403e1b6"}[chunkId] + ".chunk.js";
};